import { z } from 'zod';

import type { TranslateFn } from '@/shared/types';

export function stringMin(t: TranslateFn, min: number): z.ZodString {
    return z.string().min(min, t('validation.string.min', { count: min }));
}
